import ServicesReport from './ServicesReportPage';

export default ServicesReport;
